export function getAlphabeticalString(initialValue: string, separator = ''): string {
  return initialValue.replace(/[^a-zA-Z]/g, separator);
}
